import CustomChip from '../../../components/CustomChip';
import { useLanguage } from '../../../contexts/language';
import {
  CrewMemberCertificateStatus,
  VesselCertificateStatus,
} from '../../../types/core';
import { BADGE_CLASSNAMES } from '../../../utils/styles';

interface VesselCertificateStatusBadgeProps {
  status: VesselCertificateStatus | CrewMemberCertificateStatus;
  isExpired?: boolean;
}

const getChipClasses = (
  status: VesselCertificateStatus | CrewMemberCertificateStatus,
) => {
  switch (status) {
    case VesselCertificateStatus.Approved:
    case CrewMemberCertificateStatus.Approved:
      return BADGE_CLASSNAMES.GREEN;
    case VesselCertificateStatus.Rejected:
    case CrewMemberCertificateStatus.Rejected:
      return BADGE_CLASSNAMES.RED;
    case VesselCertificateStatus.PendingApproval:
    case CrewMemberCertificateStatus.PendingApproval:
      return BADGE_CLASSNAMES.YELLOW;
    default:
      return '';
  }
};

const VesselCertificateStatusBadge = ({
  status,
  isExpired = false,
}: VesselCertificateStatusBadgeProps) => {
  const chipClass = getChipClasses(status);
  const { t } = useLanguage();

  return (
    <>
      <CustomChip
        label={t(`vessel-certificate-status.${status}`)}
        className={chipClass}
        small
      />
      {isExpired && (
        <CustomChip
          label={t(`content.expired`)}
          className={BADGE_CLASSNAMES.RED}
          small
        />
      )}
    </>
  );
};

export default VesselCertificateStatusBadge;
